<div class="grid-stack-item-content">
  <div
    class="widget-heading"
    (mousedown)="onMouseDown()"
    (mouseup)="onMouseUp()"
  >
    <div class="title">{{ title }}</div>
    <div class="options">
      <button mat-icon-button class="option-button">
        <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
      </button>
    </div>
  </div>
  h: {{ widget.height }} w: {{ widget.width }} x: {{ widget.xPosition }} y:
  {{ widget.yPosition }}
</div>
